module.exports = __webpack_public_path__ + "media/icons/plus-67d64a99.png";